import React from "react";
import { IconButton, Tooltip } from "@toddle-edu/ds-web";
import { LockOpenOutlined, LockOutlined } from "@toddle-edu/ds-icons";
import { t } from "i18next";

const SubmissionLockStatus = props => {
  const {
    isSubmissionLocked,
    onUpdateProjectDeadlineSubmission,
    submissionId,
    testId,
    disabled,
  } = props;

  const tooltip = isSubmissionLocked
    ? t("project:open_for_submission")
    : t("project:close_for_submission");

  return (
    <Tooltip tooltip={tooltip}>
      <IconButton
        dsVersion="2.0"
        variant="neutral"
        type="outlined"
        disabled={disabled}
        icon={isSubmissionLocked ? <LockOutlined /> : <LockOpenOutlined />}
        onClick={() => {
          onUpdateProjectDeadlineSubmission({
            input: {
              submissionIds: [submissionId],
              propertiesToUpdate: {
                isLocked: !isSubmissionLocked,
              },
            },
          });
        }}
        testId={`${testId}-submission-lock-status-button`}
      />
    </Tooltip>
  );
};

export default SubmissionLockStatus;
